import React from 'react'
import { SettingsSectionV2 } from './SettingsSectionV2'

/*
 * System → Integrations → Telegram: TELEGRAM_BOT_WEBHOOK, the Bot API address
 * (with the bot token) Telegram campaigns send through — every message is a
 * POST to it + /sendPhoto. A secret: admin_audit keeps only its last four characters.
 */
const GROUPS = [
  { key: 'telegram', title: 'Campaign bot', sub: 'The bot that sends Telegram campaigns' },
]

export function TelegramSettingsV2() {
  return (
    <SettingsSectionV2
      title="Telegram"
      intro="The bot Telegram campaigns are sent through. A value saved here replaces the ConfigMap one and works without a restart."
      groups={GROUPS}
      saveNote={() => 'Used from the next message — a campaign already sending switches to it.'}
    />
  )
}
